'use strict';

(function() {
  /**
   * PublicationsService - service de gestion des publications
   */
  angular
    .module('observatoireApp')
    .service('PublicationsService', ['$http', '$q', function($http, $q) {
      
      // Configuration de l'API
      var API_URL = '/api/publications';
      
      /**
       * Convertit une date au format LocalDateTime de Java (tableau) en objet Date JavaScript
       * @param {Array|String|Date} dateValue - La valeur de date à convertir
       * @returns {Date|String} - Un objet Date ou la valeur originale si la conversion a échoué
       */
      function convertJavaLocalDateTimeToJs(dateValue) {
        try {
          // Si c'est déjà un objet Date, le retourner
          if (dateValue instanceof Date) {
            return dateValue;
          }
          
          // Si c'est un tableau comme [2023, 12, 15, 0, 0]
          if (Array.isArray(dateValue) && dateValue.length >= 3) {
            // Soustraire 1 du mois car en JavaScript les mois sont 0-indexés (0-11)
            var jsDate = new Date(dateValue[0], dateValue[1] - 1, dateValue[2]);
            
            // Si le tableau a des heures/minutes/secondes
            if (dateValue.length >= 5) {
              jsDate.setHours(dateValue[3], dateValue[4], (dateValue.length > 5 ? dateValue[5] : 0));
            }
            
            return jsDate;
          }
          
          // Si c'est une chaîne ISO
          if (typeof dateValue === 'string') {
            return new Date(dateValue);
          }
          
          // Si aucune conversion n'est possible, retourner la valeur originale
          return dateValue;
        } catch (e) {
          console.error('Erreur lors de la conversion de la date:', e, dateValue);
          return dateValue;
        }
      }
      
      // Conservation des données mockées pour la compatibilité et la gestion d'erreurs
      // Ces données ne seront utilisées qu'en cas d'échec de la connexion à l'API
      var mockPublications = [
        {
          id: 1,
          title: 'Rapport annuel de transparence 2024',
          description: 'Ce rapport présente les activités et réalisations de l\'Observatoire Tchadien des Finances Publiques pour l\'année 2024.',
          category: 'rapport',
          date: '2024-12-15',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/rapport-annuel-2024.jpg',
          fileUrl: 'assets/docs/rapport-annuel-2024.pdf',
          fileSize: '3.2 MB',
          fileType: 'PDF',
          downloads: 124,
          views: 356,
          rating: 4.2,
          ratingCount: 45,
          userRating: 0,
          tags: ['transparence', 'finances', 'rapport', '2024']
        },
        {
          id: 2,
          title: 'Guide du budget citoyen 2025',
          description: 'Ce guide explique de manière simplifiée le budget national 2025 pour permettre aux citoyens de comprendre l\'allocation des ressources publiques.',
          category: 'guide',
          date: '2025-01-10',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/guide-budget-citoyen.jpg',
          fileUrl: 'assets/docs/guide-budget-citoyen-2025.pdf',
          fileSize: '2.8 MB',
          fileType: 'PDF',
          downloads: 256,
          views: 512,
          rating: 4.7,
          ratingCount: 86,
          userRating: 0,
          tags: ['budget', 'citoyen', 'guide', '2025']
        },
        {
          id: 3,
          title: 'Analyse des recettes pétrolières 2024',
          description: 'Cette étude analyse en détail les recettes pétrolières du Tchad pour l\'année 2024 et leur impact sur l\'économie nationale.',
          category: 'etude',
          date: '2024-11-05',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/analyse-petrole.jpg',
          fileUrl: 'assets/docs/analyse-recettes-petrolieres-2024.pdf',
          fileSize: '4.5 MB',
          fileType: 'PDF',
          downloads: 178,
          views: 427,
          rating: 3.9,
          ratingCount: 38,
          userRating: 0,
          tags: ['pétrole', 'recettes', 'analyse', '2024']
        },
        {
          id: 4,
          title: 'Bulletin trimestriel - T1 2025',
          description: 'Ce bulletin présente les principales actualités et données économiques du premier trimestre 2025.',
          category: 'bulletin',
          date: '2025-04-02',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/bulletin-t1-2025.jpg',
          fileUrl: 'assets/docs/bulletin-t1-2025.pdf',
          fileSize: '1.7 MB',
          fileType: 'PDF',
          downloads: 89,
          views: 234,
          rating: 4.0,
          ratingCount: 27,
          userRating: 0,
          tags: ['bulletin', 'trimestre', 'économie', '2025']
        },
        {
          id: 5,
          title: 'Étude sur la transparence des industries extractives',
          description: 'Cette étude analyse le niveau de transparence dans le secteur des industries extractives au Tchad.',
          category: 'etude',
          date: '2024-09-18',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/transparence-extractives.jpg',
          fileUrl: 'assets/docs/etude-transparence-extractives.pdf',
          fileSize: '5.1 MB',
          fileType: 'PDF',
          downloads: 132,
          views: 305,
          rating: 4.3,
          ratingCount: 42,
          userRating: 0,
          tags: ['transparence', 'extractives', 'étude']
        },
        {
          id: 6,
          title: 'Manuel sur l\'accès à l\'information budgétaire',
          description: 'Ce manuel explique comment accéder aux informations budgétaires publiques et comment les interpréter.',
          category: 'guide',
          date: '2024-07-22',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/manuel-information.jpg',
          fileUrl: 'assets/docs/manuel-information-budgetaire.pdf',
          fileSize: '2.3 MB',
          fileType: 'PDF',
          downloads: 215,
          views: 478,
          rating: 4.5,
          ratingCount: 62,
          userRating: 0,
          tags: ['information', 'budget', 'guide', 'accès']
        },
        {
          id: 7,
          title: 'Rapport de suivi des dépenses publiques - Secteur Santé',
          description: 'Ce rapport analyse l\'exécution des dépenses publiques dans le secteur de la santé pour l\'année 2024.',
          category: 'rapport',
          date: '2024-10-30',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/rapport-sante.jpg',
          fileUrl: 'assets/docs/rapport-suivi-depenses-sante.pdf',
          fileSize: '3.8 MB',
          fileType: 'PDF',
          downloads: 147,
          views: 365,
          rating: 4.1,
          ratingCount: 33,
          userRating: 0,
          tags: ['santé', 'dépenses', 'rapport', '2024']
        },
        {
          id: 8,
          title: 'Note d\'analyse sur la dette publique',
          description: 'Cette note analyse l\'évolution de la dette publique du Tchad et ses perspectives.',
          category: 'note',
          date: '2025-02-15',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/note-dette.jpg',
          fileUrl: 'assets/docs/note-dette-publique.pdf',
          fileSize: '1.5 MB',
          fileType: 'PDF',
          downloads: 103,
          views: 218,
          rating: 3.8,
          ratingCount: 25,
          userRating: 0,
          tags: ['dette', 'analyse', 'finances', '2025']
        },
        {
          id: 9,
          title: 'Synthèse des recommandations pour la transparence budgétaire',
          description: 'Ce document présente une synthèse des recommandations pour améliorer la transparence budgétaire au Tchad.',
          category: 'synthese',
          date: '2024-08-05',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/synthese-transparence.jpg',
          fileUrl: 'assets/docs/synthese-recommandations-transparence.pdf',
          fileSize: '2.1 MB',
          fileType: 'PDF',
          downloads: 167,
          views: 389,
          rating: 4.4,
          ratingCount: 49,
          userRating: 0,
          tags: ['transparence', 'budget', 'recommandations']
        },
        {
          id: 10,
          title: 'Étude sur la mobilisation des ressources fiscales',
          description: 'Cette étude examine les stratégies de mobilisation des ressources fiscales au Tchad et propose des améliorations.',
          category: 'etude',
          date: '2025-03-20',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/etude-fiscale.jpg',
          fileUrl: 'assets/docs/etude-ressources-fiscales.pdf',
          fileSize: '4.2 MB',
          fileType: 'PDF',
          downloads: 94,
          views: 203,
          rating: 3.7,
          ratingCount: 21,
          userRating: 0,
          tags: ['fiscal', 'ressources', 'étude', '2025']
        },
        {
          id: 11,
          title: 'Guide des marchés publics pour la société civile',
          description: 'Ce guide explique les procédures des marchés publics et comment la société civile peut participer à leur suivi.',
          category: 'guide',
          date: '2024-06-12',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/guide-marches.jpg',
          fileUrl: 'assets/docs/guide-marches-publics.pdf',
          fileSize: '3.0 MB',
          fileType: 'PDF',
          downloads: 178,
          views: 412,
          rating: 4.6,
          ratingCount: 53,
          userRating: 0,
          tags: ['marchés publics', 'guide', 'société civile']
        },
        {
          id: 12,
          title: 'Rapport d\'évaluation de l\'indice de transparence budgétaire',
          description: 'Ce rapport présente les résultats de l\'évaluation de l\'indice de transparence budgétaire du Tchad pour l\'année 2024.',
          category: 'rapport',
          date: '2025-01-25',
          author: 'Observatoire Tchadien des Finances Publiques',
          thumbnail: 'assets/images/publications/rapport-indice.jpg',
          fileUrl: 'assets/docs/rapport-indice-transparence.pdf',
          fileSize: '3.5 MB',
          fileType: 'PDF',
          downloads: 122,
          views: 287,
          rating: 4.2,
          ratingCount: 37,
          userRating: 0,
          tags: ['transparence', 'indice', 'évaluation', '2024']
        }
      ];
      
      // Catégories de publications
      var mockCategories = [
        { id: 'rapport', name: 'Rapports' },
        { id: 'guide', name: 'Guides' },
        { id: 'etude', name: 'Études' },
        { id: 'bulletin', name: 'Bulletins' },
        { id: 'note', name: 'Notes d\'analyse' },
        { id: 'synthese', name: 'Synthèses' }
      ];
      
      /**
       * Soumet une note pour une publication
       * @param {number} id - L'ID de la publication
       * @param {number} rating - La note (1-5)
       * @returns {Promise} Une promesse avec la publication mise à jour
       */
      this.ratePublication = function(id, rating) {
        // S'assurer que la note est entre 1 et 5
        rating = Math.min(Math.max(parseInt(rating) || 0, 1), 5);
        
        console.log('Appel API - ratePublication vers:', API_URL + '/' + id + '/rate');
        
        // Enregistrer la note de l'utilisateur dans le localStorage pour persistance côté client
        try {
          var savedRatings = JSON.parse(localStorage.getItem('publicationRatings') || '{}');
          var previousUserRating = savedRatings[id] || 0;
          savedRatings[id] = rating;
          localStorage.setItem('publicationRatings', JSON.stringify(savedRatings));
        } catch (e) {
          console.error('Erreur lors de l\'enregistrement local de la note', e);
        }
        
        return $http.post(API_URL + '/' + id + '/rate', { rating: rating })
          .then(function(response) {
            console.log('Réponse API - ratePublication:', response);
            
            if (response.data) {
              // Transformer les données pour le format attendu par le frontend
              var item = response.data;
              var result = {
                id: item.id,
                title: item.title,
                description: item.description,
                category: item.category ? item.category.id : item.type,
                categoryName: item.category ? item.category.name : null,
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                // Utiliser explicitement les valeurs de notation renvoyées par l'API
                rating: parseFloat(item.rating) || 0,
                ratingCount: parseInt(item.ratingCount) || 0,
                // Définir la note de l'utilisateur à la valeur fournie
                userRating: parseInt(rating),
                tags: item.tags || []
              };
              
              // Ajouter la note de l'utilisateur depuis la mémoire locale
              result.userRating = rating;
              
              return result;
            }
            
            // Si pas de données retournées, récupérer la publication avec la note mise à jour
            return this.getPublicationById(id)
              .then(function(publication) {
                // Ajouter la note de l'utilisateur depuis la mémoire locale
                publication.userRating = rating;
                return publication;
              });
          }.bind(this))
          .catch(function(error) {
            console.error('Erreur lors de la soumission de la note:', error);
            
            // En cas d'erreur, mettre à jour localement dans les données mockées
            var publication = mockPublications.find(function(pub) {
              return pub.id === parseInt(id);
            });
            
            if (publication) {
              // Stocker la note de l'utilisateur
              var previousUserRating = publication.userRating || 0;
              publication.userRating = rating;
              
              // Si c'est une première note (et non une modification), ajouter au compteur
              if (previousUserRating === 0) {
                publication.ratingCount = (publication.ratingCount || 0) + 1;
              }
              
              // Recalculer la note moyenne localement
              if (previousUserRating > 0) {
                // Si l'utilisateur change sa note, ajuster la moyenne
                var totalPoints = publication.rating * publication.ratingCount;
                totalPoints = totalPoints - previousUserRating + rating;
                publication.rating = totalPoints / publication.ratingCount;
              } else {
                // Si c'est une nouvelle note
                var totalRating = (publication.rating || 0) * (publication.ratingCount - 1) + rating;
                publication.rating = totalRating / publication.ratingCount;
              }
              
              // Arrondir à une décimale
              publication.rating = Math.round(publication.rating * 10) / 10;
              
              return publication;
            } else {
              throw new Error('Publication non trouvée');
            }
          });
      };
      
      /**
       * Récupère toutes les publications
       * @returns {Promise} Une promesse avec les publications
       */
      this.getAllPublications = function() {
        console.log('Appel API - getAllPublications vers:', API_URL);
        
        return $http.get(API_URL)
          .then(function(response) {
            console.log('Réponse API - getAllPublications:', response);
            var publications = [];
            
            // Vérifier la structure de la réponse et adapter l'extraction des données
            if (response.data && response.data.content && Array.isArray(response.data.content)) {
              // Format paginé
              publications = response.data.content;
              console.log('Format paginé détecté, nombre de publications:', publications.length);
            } else if (Array.isArray(response.data)) {
              // Format tableau
              publications = response.data;
              console.log('Format tableau détecté, nombre de publications:', publications.length);
            } else if (typeof response.data === 'object') {
              // Format objet unique
              publications = [response.data];
              console.log('Format objet unique détecté');
            }
            
            // Transformer les données pour qu'elles correspondent au format attendu par le frontend
            return publications.map(function(item) {
              // Log pour débogage
              console.log('Publication brute du backend:', item);
              
              var pubDto = {
                id: item.id,
                title: item.title,
                description: item.description,
                // Utiliser l'objet category tel qu'il est retourné par le backend
                category: item.category ? item.category.id : item.type,
                // Ajouter le nom de la catégorie pour l'affichage
                categoryName: item.category ? item.category.name : null,
                // Convertir les dates LocalDateTime de Java en objets Date JavaScript
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                rating: item.rating || 0,
                ratingCount: item.ratingCount || 0,
                userRating: 0,
                tags: item.tags || []
              };
              
              console.log('Publication transformée pour le frontend:', pubDto);
              return pubDto;
            });
          })
          .catch(function(error) {
            console.warn('Utilisation des données mockées comme solution de repli', error);
            return mockPublications.map(function(pub) {
              var cat = mockCategories.find(function(c) { return c.id === pub.category; });
              var enriched = {};
              for (var k in pub) { if (pub.hasOwnProperty(k)) enriched[k] = pub[k]; }
              enriched.categoryName = cat ? cat.name : pub.category;
              return enriched;
            });
          });
      };
      
      /**
       * Récupère une publication par son ID
       * @param {number} id - L'ID de la publication
       * @returns {Promise} Une promesse avec la publication
       */
      this.getPublicationById = function(id) {
        console.log('Appel API - getPublicationById vers:', API_URL + '/' + id);
        
        return $http.get(API_URL + '/' + id)
          .then(function(response) {
            console.log('Réponse API - getPublicationById:', response);
            
            if (!response.data) {
              throw new Error('Données de publication non trouvées');
            }
            
            // Transformer les données pour le format attendu par le frontend
            var item = response.data;
            return {
              id: item.id,
              title: item.title,
              description: item.description,
              category: item.type,
              date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
              author: item.author,
              thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
              fileUrl: item.pdfUrl,
              fileSize: item.fileSize || '1 MB',
              fileType: item.fileType || 'PDF',
              downloads: item.downloads || 0,
              views: item.views || 0,
              rating: item.rating || 0,
              ratingCount: item.ratingCount || 0,
              userRating: 0,
              tags: item.tags || []
            };
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération de la publication:', error);
            
            // En cas d'erreur, rechercher dans les données mockées
            console.warn('Recherche dans les données mockées');
            var publication = mockPublications.find(function(pub) {
              return pub.id === parseInt(id);
            });
            
            if (publication) {
              return publication;
            } else {
              throw new Error('Publication non trouvée');
            }
          });
      };
      
      /**
       * Incrémente le nombre de vues d'une publication
       * @param {number} id - L'ID de la publication
       * @returns {Promise} Une promesse avec la publication mise à jour
       */
      this.incrementViews = function(id) {
        console.log('Appel API - incrementViews vers:', API_URL + '/' + id + '/view');
        
        return $http.post(API_URL + '/' + id + '/view')
          .then(function(response) {
            console.log('Réponse API - incrementViews:', response);
            
            if (response.data) {
              // Transformer les données pour le format attendu par le frontend
              var item = response.data;
              return {
                id: item.id,
                title: item.title,
                description: item.description,
                category: item.type,
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                rating: item.rating || 0,
                ratingCount: item.ratingCount || 0,
                userRating: 0,
                tags: item.tags || []
              };
            }
            
            // Si pas de données retournées, récupérer la publication avec le compteur incrémenté
            return this.getPublicationById(id);
          }.bind(this))
          .catch(function(error) {
            console.error('Erreur lors de l\'incrémentation des vues:', error);
            
            // En cas d'erreur, mettre à jour localement dans les données mockées
            var publication = mockPublications.find(function(pub) {
              return pub.id === parseInt(id);
            });
            
            if (publication) {
              publication.views = (publication.views || 0) + 1;
              return publication;
            } else {
              throw new Error('Publication non trouvée');
            }
          });
      };
      
      /**
       * Incrémente le nombre de téléchargements d'une publication
       * @param {number} id - L'ID de la publication
       * @returns {Promise} Une promesse avec la publication mise à jour
       */
      this.incrementDownloads = function(id) {
        console.log('Appel API - incrementDownloads vers:', API_URL + '/' + id + '/download');
        
        return $http.post(API_URL + '/' + id + '/download')
          .then(function(response) {
            console.log('Réponse API - incrementDownloads:', response);
            
            if (response.data) {
              // Transformer les données pour le format attendu par le frontend
              var item = response.data;
              return {
                id: item.id,
                title: item.title,
                description: item.description,
                category: item.type,
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                rating: item.rating || 0,
                ratingCount: item.ratingCount || 0,
                userRating: 0,
                tags: item.tags || []
              };
            }
            
            // Si pas de données retournées, récupérer la publication avec le compteur incrémenté
            return this.getPublicationById(id);
          }.bind(this))
          .catch(function(error) {
            console.error('Erreur lors de l\'incrémentation des téléchargements:', error);
            
            // En cas d'erreur, mettre à jour localement dans les données mockées
            var publication = mockPublications.find(function(pub) {
              return pub.id === parseInt(id);
            });
            
            if (publication) {
              publication.downloads = (publication.downloads || 0) + 1;
              return publication;
            } else {
              throw new Error('Publication non trouvée');
            }
          });
      };
      
      /**
       * Soumet une note pour une publication
      this.loadUserRatings = function() {
        try {
          return JSON.parse(localStorage.getItem('publicationRatings') || '{}');
        } catch (e) {
          console.error('Erreur lors du chargement des notes utilisateur', e);
          return {};
        }
      };
      
      /**
       * Récupère les publications par catégorie
       * @param {string} category - La catégorie à filtrer
       * @returns {Promise} Une promesse avec les publications filtrées
       */
      this.getPublicationsByCategory = function(category) {
        var deferred = $q.defer();
        
        // Simulation d'une requête API
        setTimeout(function() {
          var filtered = mockPublications.filter(function(pub) {
            return pub.category === category;
          });
          
          deferred.resolve(filtered);
        }, 300);
        
        return deferred.promise;
      };
      
      /**
       * Récupère les catégories de publications
       * @returns {Promise} Une promesse avec les catégories
       */
      this.getCategories = function() {
        console.log('Appel API - getCategories vers:', API_URL + '/categories');
        
        return $http.get(API_URL + '/categories')
          .then(function(response) {
            console.log('Réponse API - getCategories:', response);
            
            // Vérifier la structure de la réponse et adapter l'extraction des données
            if (response.data && Array.isArray(response.data)) {
              return response.data;
            } else if (response.data && Array.isArray(response.data.content)) {
              return response.data.content;
            } else {
              console.warn('Structure de réponse inattendue pour les catégories:', response.data);
              return [];
            }
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des catégories:', error);
            // En cas d'erreur, utiliser les données mockées comme solution de repli
            console.warn('Utilisation des catégories mockées comme solution de repli');
            return mockCategories;
          });
      };
      
      /**
       * Recherche des publications
       * @param {string} query - Le terme de recherche
       * @returns {Promise} Une promesse avec les résultats de recherche
       */
      this.searchPublications = function(query) {
        // Si la requête est vide, simplement retourner toutes les publications
        if (!query || query.trim() === '') {
          return this.getAllPublications();
        }
        
        console.log('Appel API - searchPublications vers:', API_URL + '/search');
        
        return $http.get(API_URL + '/search', {
          params: {
            keyword: query,
            page: 0,
            size: 50
          }
        })
        .then(function(response) {
          console.log('Réponse API - searchPublications:', response);
          var publications = [];
          
          // Vérifier la structure de la réponse et adapter l'extraction des données
          if (response.data && response.data.content && Array.isArray(response.data.content)) {
            publications = response.data.content;
          } else if (Array.isArray(response.data)) {
            publications = response.data;
          } else if (typeof response.data === 'object') {
            publications = [response.data];
          }
          
          // Transformer les données pour qu'elles correspondent au format attendu par le frontend
          return publications.map(function(item) {
            return {
              id: item.id,
              title: item.title,
              description: item.description,
              // Utiliser la catégorie si disponible, sinon revenir au type pour la compatibilité
              category: (item.category && item.category.id) ? item.category.id : item.type,
              categoryName: (item.category && item.category.name) ? item.category.name : null,
              date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
              author: item.author,
              thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
              fileUrl: item.pdfUrl,
              fileSize: item.fileSize || '1 MB',
              fileType: item.fileType || 'PDF',
              downloads: item.downloads || 0,
              views: item.views || 0,
              rating: item.rating || 0,
              ratingCount: item.ratingCount || 0,
              userRating: 0,
              tags: item.tags || []              
            };
          });
        })
        .catch(function(error) {
          console.error('Erreur lors de la recherche de publications:', error);
          
          // En cas d'erreur, faire une recherche locale dans les données mockées
          console.warn('Utilisation des données mockées pour la recherche');
          query = query.toLowerCase();
          return mockPublications.filter(function(pub) {
            return pub.title.toLowerCase().indexOf(query) !== -1 ||
                   pub.description.toLowerCase().indexOf(query) !== -1 ||
                   pub.tags.some(function(tag) {
                     return tag.toLowerCase().indexOf(query) !== -1;
                   });
          });
        });
      };
      
      /**
       * Récupère les notes attribuées par l'utilisateur aux publications depuis le localStorage
       * @returns {Object} Un objet avec les IDs des publications comme clés et les notes comme valeurs
       */
      this.loadUserRatings = function() {
        try {
          var userRatingsString = localStorage.getItem('publications_user_ratings');
          return userRatingsString ? JSON.parse(userRatingsString) : {};
        } catch (e) {
          console.error('Erreur lors du chargement des notes utilisateur:', e);
          return {};
        }
      };
      
      /**
       * Récupère les données de notation des publications depuis le localStorage
       * Cette fonction est nécessaire car le backend ne renvoie pas les données de notation
       * @returns {Object} Un objet avec les IDs des publications comme clés et les données de notation comme valeurs
       */
      this.loadPublicationRatings = function() {
        try {
          var ratingsString = localStorage.getItem('publications_ratings');
          return ratingsString ? JSON.parse(ratingsString) : {};
        } catch (e) {
          console.error('Erreur lors du chargement des notes de publications:', e);
          return {};
        }
      };
      
      /**
       * Sauvegarde les données de notation des publications dans le localStorage
       * @param {Object} ratings - Un objet avec les IDs des publications comme clés et les données de notation comme valeurs
       */
      this.savePublicationRatings = function(ratings) {
        try {
          localStorage.setItem('publications_ratings', JSON.stringify(ratings));
        } catch (e) {
          console.error('Erreur lors de la sauvegarde des notes de publications:', e);
        }
      };
      
      /**
       * Enregistre la note d'un utilisateur pour une publication
       * @param {number} publicationId - ID de la publication
       * @param {number} rating - Note attribuée par l'utilisateur (1-5)
       */
      /**
       * Récupère les publications récentes (les 4 plus récentes)
       * @param {number} limit - Nombre de publications à récupérer (par défaut 4)
       * @returns {Promise} Une promesse avec les publications récentes
       */
      this.getRecentPublications = function(limit) {
        limit = limit || 4; // Par défaut 4 publications
        console.log('Appel API - getRecentPublications avec limite:', limit);
        
        // On utilise /api/publications/recent pour récupérer les publications récentes
        return $http.get(API_URL + '/recent', { params: { limit: limit } })
          .then(function(response) {
            console.log('Réponse API - getRecentPublications:', response);
            var publications = [];
            
            // Vérifier la structure de la réponse et adapter l'extraction des données
            if (response.data && response.data.content && Array.isArray(response.data.content)) {
              // Format paginé
              publications = response.data.content;
            } else if (Array.isArray(response.data)) {
              // Format tableau
              publications = response.data;
            } else if (typeof response.data === 'object') {
              // Format objet unique
              publications = [response.data];
            }
            
            // Transformer les données pour qu'elles correspondent au format attendu par le frontend
            return publications.map(function(item) {
              var pubDto = {
                id: item.id,
                title: item.title,
                description: item.description,
                // Utiliser l'objet category tel qu'il est retourné par le backend
                category: item.category ? item.category.id : item.type,
                // Ajouter le nom de la catégorie pour l'affichage
                categoryName: item.category ? item.category.name : null,
                // Convertir les dates LocalDateTime de Java en objets Date JavaScript
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                rating: item.rating || 0,
                ratingCount: item.ratingCount || 0,
                userRating: 0,
                tags: item.tags || []
              };
              
              return pubDto;
            });
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des publications récentes:', error);
            // En cas d'erreur, utiliser les données mockées comme solution de repli
            console.warn('Utilisation des données mockées comme solution de repli');
            // Prendre les 'limit' premiers éléments des données mockées, triés par date décroissante
            return mockPublications
              .slice()
              .sort(function(a, b) {
                return new Date(b.date) - new Date(a.date);
              })
              .slice(0, limit);
          });
      };

      this.getFeaturedPublications = function(limit) {
        limit = limit || 4; // Par défaut 4 publications
        console.log('Appel API - getFeaturedPublications avec limite:', limit);
        
        // On utilise /api/publications/featured pour récupérer les publications récentes
        return $http.get(API_URL + '/featured', { params: { limit: limit } })
          .then(function(response) {
            console.log('Réponse API - getFeaturedPublications:', response);
            var publications = [];
            
            // Vérifier la structure de la réponse et adapter l'extraction des données
            if (response.data && response.data.content && Array.isArray(response.data.content)) {
              // Format paginé
              publications = response.data.content;
            } else if (Array.isArray(response.data)) {
              // Format tableau
              publications = response.data;
            } else if (typeof response.data === 'object') {
              // Format objet unique
              publications = [response.data];
            }
            
            // Transformer les données pour qu'elles correspondent au format attendu par le frontend
            return publications.map(function(item) {
              var pubDto = {
                id: item.id,
                title: item.title,
                description: item.description,
                // Utiliser l'objet category tel qu'il est retourné par le backend
                category: item.category ? item.category.id : item.type,
                // Ajouter le nom de la catégorie pour l'affichage
                categoryName: item.category ? item.category.name : null,
                // Convertir les dates LocalDateTime de Java en objets Date JavaScript
                date: convertJavaLocalDateTimeToJs(item.publicationDate || item.createdAt),
                author: item.author,
                thumbnail: item.coverImage || 'assets/images/publications/default.jpg',
                fileUrl: item.pdfUrl,
                fileSize: item.fileSize || '1 MB',
                fileType: item.fileType || 'PDF',
                downloads: item.downloads || 0,
                views: item.views || 0,
                rating: item.rating || 0,
                ratingCount: item.ratingCount || 0,
                userRating: 0,
                tags: item.tags || []
              };
              
              return pubDto;
            });
          })
          .catch(function(error) {
            console.error('Erreur lors de la récupération des publications en vedette:', error);
            // En cas d'erreur, utiliser les données mockées comme solution de repli
            console.warn('Utilisation des données mockées comme solution de repli');
            // Prendre les 'limit' premiers éléments des données mockées, triés par date décroissante
            return mockPublications
              .slice()
              .sort(function(a, b) {
                return new Date(b.date) - new Date(a.date);
              })
              .slice(0, limit);
          });
      };

      this.saveUserRating = function(publicationId, rating) {
        try {
          // Récupérer les notes existantes
          var userRatings = this.loadUserRatings();
          var oldRating = userRatings[publicationId] || 0;
          
          // Ajouter ou mettre à jour la note
          userRatings[publicationId] = rating;
          
          // Enregistrer dans le localStorage
          localStorage.setItem('publications_user_ratings', JSON.stringify(userRatings));
          
          // Récupérer les données de notation des publications
          var publicationRatings = this.loadPublicationRatings();
          var pubRating = publicationRatings[publicationId] || { rating: 0, ratingCount: 0 };
          
          // Mettre à jour le rating et ratingCount
          if (oldRating === 0 && rating > 0) {
            // Nouvelle notation
            pubRating.ratingCount = (pubRating.ratingCount || 0) + 1;
          } else if (oldRating > 0 && rating === 0) {
            // Suppression d'une notation
            pubRating.ratingCount = Math.max((pubRating.ratingCount || 1) - 1, 0);
          }
          
          // Calculer la nouvelle note moyenne
          if (pubRating.ratingCount > 0) {
            // Formule simplifiée pour simuler la mise à jour de la note moyenne
            pubRating.rating = ((pubRating.rating * pubRating.ratingCount) - oldRating + rating) / pubRating.ratingCount;
            pubRating.rating = Math.max(0, Math.min(5, pubRating.rating)); // Borner entre 0 et 5
          } else {
            pubRating.rating = 0;
          }
          
          // Sauvegarder les données de notation mises à jour
          publicationRatings[publicationId] = pubRating;
          this.savePublicationRatings(publicationRatings);
          
          // Appeler l'API pour enregistrer la note côté serveur (même si le backend ne traite pas les notations)
          return $http.post(API_URL + '/' + publicationId + '/rate', { rating: rating })
            .then(function(response) {
              console.log('Note enregistrée avec succès:', response);
              
              // Retourner un objet avec les informations mises à jour pour simuler la réponse de l'API
              var result = response.data || {};
              result.rating = pubRating.rating;
              result.ratingCount = pubRating.ratingCount;
              result.userRating = rating;
              
              return result;
            })
            .catch(function(error) {
              console.error('Erreur lors de l\'enregistrement de la note:', error);
              // En cas d'erreur API, retourner quand même les données locales
              var result = {
                id: publicationId,
                rating: pubRating.rating,
                ratingCount: pubRating.ratingCount,
                userRating: rating
              };
              return result;
            });
        } catch (e) {
          console.error('Erreur lors de la sauvegarde de la note:', e);
          return $q.reject(e);
        }
      };
      
    }]);
})();
